import { mapSelbstbeteiligung } from '@ps20-frontend/migrations';
import { Vertragsoptionen } from '@ps20-frontend/frontend-models';
import { StatePreV5, StateV5 } from './5_migrate_selbstbeteiligung.interface';

export const migrateSelbstbeteiligung = (
  previousState: StatePreV5,
  newVersion: number,
): StateV5 => {
  return {
    ...previousState,
    version: newVersion,
    vertragsoptionen: {
      ...previousState.vertragsoptionen,
      selbstbeteiligung: mapSelbstbeteiligung(previousState.vertragsoptionen.selbstbeteiligung),
    } as Vertragsoptionen,
  };
};
